import { render, staticRenderFns } from "./common-help.vue?vue&type=template&id=1c3ddd50&scoped=true&"
import script from "./common-help.vue?vue&type=script&lang=ts&"
export * from "./common-help.vue?vue&type=script&lang=ts&"
import style0 from "./common-help.vue?vue&type=style&index=0&id=1c3ddd50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ddd50",
  null
  
)

export default component.exports